/**
 * Just remove if user has the achievement. It will never appear again.
 *
 * @module
 */

// bounty
import {debug} from '@acng/frontend-bounty/dom/debug.js';
import {removeNode} from '@acng/frontend-bounty';
// stargazer & relativity
import {Watch} from '@acng/frontend-relativity';
import {AttributeLink, AttributeSetup, task} from '@acng/frontend-stargazer';
// enterprise
import {ctxVipPoints} from '../context/points.js';
import {userHas} from '../service/cache.js';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';
import {remove} from '@acng/frontend-bounty/dom/move.js';
import {compile} from '../service/template.js';

const DEBUG_ALL = false;

/**
 * Remove the element if the user has achieved a specified challenge.
 *
 * @example
 *
 * ```html
 * <span without-achievement="clicked-the-stuff">
 *   <a href="...">Click here</a>
 *   to click the stuff and achieve "clicked-the-stuff".
 * </a>
 * ```
 *
 * ### Formal Syntax
 *
 *     without-achievement = <name>
 *     <name> := $(echo select name from acng.achievements | mysql -N)
 *
 * @group DOM Attribute
 */
export const WITHOUT_ACHIEVEMENT = 'without-achievement';

AttributeSetup(WITHOUT_ACHIEVEMENT, (name) => {
  /**
   * There is no achievement event a.t.m.
   * So watch for points value.
   */
  const watch = Watch(attributeSelector(name), ctxVipPoints);

  /**
   * @param {Element} element
   * @param {string} challengeName
   *
   * @returns {Promise<void>}
   */
  const check = async (element, challengeName) => {
    DEBUG: if (debug(element)) console.log(`check [${name}=${challengeName}]...`, {element});

    if (await userHas(challengeName)) {
      DEBUG: if (debug(element)) console.log(`...async remove [${name}=${challengeName}]`, {element});
      remove(element);
    }
  };

  AttributeLink(name, (element, achievement) =>
    watch(element, (element) => {
      check(element, achievement);
    }),
  );

  return (element, achievement, compiler) => {
    DEBUG: if (DEBUG_ALL) element.setAttribute('debug', '');
    compile(element);
    task(compiler, check(element, achievement));
  };
});
